import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"

const ImgStyled = styled(Img)`
  margin: auto 2px;
`

const socialMediaUrls = {
  "github": "https://www.github.com/n-ulricksen",
  "linkedin": "https://www.linkedin.com/in/n-ulricksen/",
}

export default function SocialMediaIcons() {
  const data = useStaticQuery(query)

  const icons = data.allFile.nodes.map(image => (
    <a href={socialMediaUrls[image.name]} target="_blank" rel="noopener noreferrer" key={image.id}>
      <ImgStyled fixed={image.childImageSharp.fixed} />
    </a>
  ))

  return (
    <div>
      {icons}
    </div>
  )
}

const query = graphql`
    query GetSocialIcons {
      allFile(filter: {relativeDirectory: {eq: "social"}}) {
        nodes {
          id
          name
          childImageSharp {
            fixed(height: 40, width: 40) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    }
  `
